<script setup lang="ts">
    import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
    } from '@/components/ui/alert-dialog';
    import { ref } from 'vue';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import { useVoucherStore } from '@/stores/voucher';
    import axios from 'axios';

    const { t } = useI18n();

    const voucherStore = useVoucherStore();

    const accounts = ref<any[]>([]);

    const defineEmit = defineEmits<{
        (e: 'delete-statements'): void;
    }>();

    const { mutate, isPending } = useMutation({
        mutationFn: (formData: { accounts: any[] }) =>
            axios.post(route('v2.voucher.admin.statement.delete'), formData),
        onSuccess: (data) => {
            console.log(data);
        },
        onError: (error: any) => {
            toast.error(error.response.data.message || t('forms.system_error'));
        },
    });

    function deleteStatements() {
        defineEmit('delete-statements');
        // mutate({
        //     accounts: accounts.value,
        // });
    }
</script>

<template>
    <AlertDialog
        :open="voucherStore.statementUploadAlertOpen"
        @update:open="(value) => voucherStore.toggleStatementUploadAlertModal(value)"
    >
        <AlertDialogContent class="sm:max-w-md">
            <AlertDialogHeader>
                <AlertDialogTitle>{{ t('vouchers.js.uploads_processing_title') }}</AlertDialogTitle>
                <AlertDialogDescription>
                    {{ t('vouchers.js.uploads_processing_content') }}
                </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>{{ t('forms.no') }}</AlertDialogCancel>
                <AlertDialogAction
                    variant="default"
                    @click="deleteStatements"
                >
                    {{ t('forms.yes') }}
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
